import { useLocation } from 'react-router-dom';
import ProfileMenu from '@components/widgets/ProfileMenu';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as LeftIcon } from '@assets/images/left_icon.svg';
import { TITLE_PATH_MAPPINGS } from '@constants';
import _find from 'lodash/find';
import { useMediaQuery } from 'usehooks-ts';
import clsx from 'clsx';
import { useAuthStore } from '@stores';

const Header = () => {
  const location = useLocation();
  const isMobile = useMediaQuery('(max-width: 720px)');
  const { pathname } = location;
  const navigate = useNavigate();
  const {
    isLender,
    isBroker,
    organisationConfig,
    brokerOrgStatus,
    brokerOrgName,
  } = useAuthStore();

  const orgBadgeLabel = (() => {
    if (isLender()) return organisationConfig.name || null;
    if (isBroker() && brokerOrgStatus === 'ACTIVE' && brokerOrgName) return brokerOrgName;
    return null;
  })();

  const back = () => {
    if (pathname.includes('/inspections/detail')) {
      navigate('/inspections');
    } else if (pathname.includes('/verifications/detail')) {
      navigate('/verifications');
    } else if (pathname.startsWith('/broker-org')) {
      // After registration, history is register → broker-org; navigate(-1) returns
      // to register, which immediately redirects back here. Go home instead.
      navigate('/');
    } else {
      navigate(-1);
    }
  };
  return (
    <div
      className={clsx(
        'flex-col bg border-b border-b-grey-200 w-full',
        isMobile ? 'hidden' : 'md:flex'
      )}>
      <div className="py-2 px-8 h-[56px] flex justify-between items-center">
        <div className="flex-1 justify-start">
          <h1 className="font-semibold text-base text-grey-900 whitespace-nowrap">
            {_find(TITLE_PATH_MAPPINGS, ['path', pathname])?.title}
            {!TITLE_PATH_MAPPINGS.some((e) => e.path === pathname) && (
              <div
                className="cursor-pointer flex justify-center items-center"
                onClick={back}>
                <LeftIcon className="mr-2 rotate-180" />
                <p className="">Back</p>
              </div>
            )}
          </h1>
        </div>
        <div className="flex items-center justify-end w-full">
          <div className="flex items-center gap-3">
            {orgBadgeLabel && (
              <span
                className="text-xs font-semibold px-2.5 py-1 rounded-full max-w-[240px] truncate"
                style={{ background: 'rgba(3,62,115,0.08)', color: '#033E73', border: '1px solid rgba(3,62,115,0.2)' }}
                title={orgBadgeLabel}>
                {orgBadgeLabel}
              </span>
            )}
            <div className="hidden md:block">
              <ProfileMenu />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
